import { Component } from '@angular/core';

import { ModalComponent } from '../../modal/modal.component';
import { BaseMenuComponent } from '../base.menu';

@Component({
    templateUrl: './file-reader.menu.html',
    standalone: false
})
export class FileReaderMenuComponent extends BaseMenuComponent {
  constructor(public modal: ModalComponent) {
    super(modal);
    this.modal.hasClassModal = true;
  }
}
